import { IEditorStreamState } from '~src/store/editor/stream/types';
import { IStudioState } from '~src/store/types';

const getStreamState = (state: IStudioState): IEditorStreamState => {
    return state.editor.stream;
};

export { getStreamState };
